import React from 'react';
import {
    View,
    StyleSheet
} from 'react-native';
import {
    JDImage,
    JDText,
    JDTouchable
} from '@jdreact/jdreact-core-lib';
import { pt } from '../../common/utils';

const BookShowItem = ({
    jdPicUrl = '',
    movieName = '',
    grade = '',
    actors = '',
    releaseDate = '',
    minTicketNum = '',
    cinemaCount = '',
    movieId = '',
    onGroupBuyClick = () => {},
    onDetailClick = () => {}
}) => {
    return (
        <View style={ styles.container }>
            <JDTouchable
                onPress={ () => {
                    onDetailClick(movieId);
                } }
            >
                <View style={ [styles.row, styles.mb16] }>

                    <View style={ styles.imgc }>
                        <JDImage
                            style={ styles.img }
                            source={ { uri: jdPicUrl } }
                        />
                    </View>
                    <View style={ styles.cc }>
                        <JDText numberOfLines={ 1 } style={ styles.title }>{movieName}</JDText>
                        <View style={ [styles.row, styles.mb4] }>
                            {
                                grade && grade !== 'null' && grade !== '0'
                                    ? (
                                        <>
                                            <JDText style={ styles.fontGray }>观众评分</JDText>
                                            <JDText
                                                type='regular'
                                                style={ styles.fontYellow }
                                            >{grade}</JDText>
                                        </>
                                    )
                                    : (
                                        <JDText style={ styles.fontGray }>暂无评分</JDText>
                                    )
                            }
                        </View>
                        {
                            actors
                                ? (

                                    <JDText
                                        numberOfLines={ 1 }
                                        style={ [styles.fontGray, styles.mb4] }
                                    >
                                    主演: {actors}
                                    </JDText>
                                )
                                : null
                        }
                        <View style={ styles.row }>
                            <JDText
                                numberOfLines={ 1 }
                                style={ [styles.fontGray, styles.font11] }
                            >
                                {releaseDate}
                                <JDText
                                    style={ styles.fontGray }
                                >
                                在中国大陆上映
                                </JDText>
                            </JDText>

                        </View>

                    </View>
                </View>
            </JDTouchable>

            <View
                style={ styles.row }
            >
                <JDImage
                    style={ [styles.row, styles.leftC] }
                    source={ { uri: 'https://img11.360buyimg.com/imagetools/jfs/t1/280117/32/8716/28112/67e14559F15c16a83/2d3174b935536ce8.png' } }
                >
                    <JDText style={ styles.fontBlack }>
                        最低
                    </JDText>
                    <JDText style={ styles.fontRed }>
                        {minTicketNum}人
                    </JDText>
                    <JDText style={ styles.fontBlack }>
                        开场
                    </JDText>
                    <JDText style={ [styles.ss, styles.fontGray] }>|</JDText>
                    <JDText style={ styles.fontRed }>
                        {cinemaCount}家
                    </JDText>
                    <JDText style={ styles.fontBlack }>
                        影院可拼场
                    </JDText>
                </JDImage>
                <JDTouchable
                    onPress={ () => {
                        onGroupBuyClick(movieId);
                    } }
                >

                    <JDImage
                        style={ styles.bc }
                        source={ { uri: 'https://img12.360buyimg.com/imagetools/jfs/t1/280200/24/8220/16782/67e147b2F225ee7b1/3cf3370be7f8101a.png' } }
                    >
                        <JDText style={ styles.bt }>拼场购票</JDText>
                    </JDImage>
                </JDTouchable>
            </View>
        </View>
    );
};

export default BookShowItem;

const styles = StyleSheet.create({
    container: {
        flexDirection: 'column',
        backgroundColor: '#fff',
        paddingTop: pt(16),
        paddingBottom: pt(16),
        paddingLeft: pt(14),
        paddingRight: pt(14)
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    imgc: {
        width: pt(60),
        height: pt(88),
        marginRight: pt(16)
    },
    img: {
        width: pt(60),
        height: pt(88)
    },
    cc: {
        flexDirection: 'column'
    },
    title: {
        fontSize: pt(16),
        fontWeight: 'bold',
        marginBottom: pt(6),
        width: pt(270)
    },
    fontGray: {
        color: '#666666',
        fontSize: pt(12)
    },
    fontYellow: {
        color: '#FFAE18',
        fontSize: pt(12)
    },
    fontBlack: {
        color: '#222222',
        fontSize: pt(12)
    },
    fontRed: {
        color: '#FA2714',
        fontSize: pt(12)
    },
    mb4: {
        marginBottom: pt(6)
    },
    font11: {
        fontSize: pt(11)
    },
    ss: {
        paddingLeft: pt(2),
        paddingRight: pt(2)
    },
    leftC: {
        width: pt(271),
        height: pt(32),
        paddingLeft: pt(10)
    },
    mb16: {
        marginBottom: pt(16)
    },
    bc: {
        width: pt(76),
        height: pt(32),
        justifyContent: 'center',
        alignItems: 'center'
    },
    bt: {
        color: '#fff',
        fontSize: pt(12),
        fontWeight: 'bold'
    }
});
